import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useTimer } from "react-timer-hook";
import NetButton from "./NetButton";
import Music from "./Music";
import { useLocation } from "react-router-dom";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import {
  doc,
  setDoc,
  updateDoc,
  collection,
  getDoc,
  where,
  onSnapshot,
  query,
} from "firebase/firestore";
import AutohideToast from "./AutohideToast";
import { useCollectionData } from "react-firebase-hooks/firestore";
import AirOutlinedIcon from "@mui/icons-material/AirOutlined";
import { useAuthState } from "react-firebase-hooks/auth";
import { db, auth } from "./firebase";
//Ring, Hypnosis, TwinSpin,
// import CustomBots from "./CustomBots";
import { SpinStretch } from "react-cssfx-loading";
import { Typewriter } from "react-simple-typewriter";
import { Toast } from "react-bootstrap";
import Wallpaper from "./Wallpaper";
import OnlinePop from "./OnlinePop";
import { AnimatedToggle } from "./ui/animated-toggle";
import TimerPiP, { isPiPSupported } from "./TimerPiP";

// ── Focus-session tracking (survives device sleep / tab kill) ──
// A record is written when a focus session starts and removed when it
// completes normally. If a stale record is found on mount, the session was
// interrupted and we ask the user whether to credit the elapsed minutes.
const ACTIVE_SESSION_KEY = "activeFocusSession";

function readActiveSession() {
  try {
    return JSON.parse(localStorage.getItem(ACTIVE_SESSION_KEY));
  } catch {
    return null;
  }
}
function saveActiveSession(durationMinutes) {
  localStorage.setItem(
    ACTIVE_SESSION_KEY,
    JSON.stringify({
      startedAt: Date.now(),
      durationMinutes,
      curDate: new Date().toDateString(),
    }),
  );
}
function clearActiveSession() {
  localStorage.removeItem(ACTIVE_SESSION_KEY);
}

function Timer({
  onlyTimer,
  expiryTimestamp,
  setheading,
  allusers,
  user,
  setcustomlink,
  setwallpaperclick,
  wallpaperclick,
  setfocusingclick,
  focusingclick,
  setAtime,
  Atime,
  setbreathevisible,
  setTimerrunning,
  pipOpen,
  onPipClose,
  timerMaximized,
  onMaximizeClose,
}) {
  // console.log(navigator.onLine)
  // console.log(allusers);
  // const [user] = useAuthState(auth);
  // const [AllUsers, setAllUsers] = useState(allusers);

  const [userRef, setUserRef] = useState(null);

  // const usersRef = collection(db, "users");
  // const allusersQuery = query(usersRef);
  // ,where("status.studying", "==", true)
  // const [allusers, setallusers] = useState(props.allusers);
  // const [allusers] = useCollectionData(allusersQuery, { idField: "id" });

  // console.log("read");
  const [focuspeople, setfocuspeople] = useState(0);

  const location = useLocation();

  // audiooo
  let radioaudio = new Audio("./audios/radio-click_out.aac");
  radioaudio.playbackRate = 1.5;
  radioaudio.volume = 0.8;
  let timeraudio = new Audio("./audios/tick-tock2_out.aac");
  timeraudio.playbackRate = 2;
  timeraudio.volume = 0.6;
  let pauseaudio = new Audio("./audios/pause_out.aac");
  let resumeaudio = new Audio("./audios/resume_out.aac");
  let finishaudio = new Audio("./audios/finish_out.aac");

  ////////////////

  async function setQuote() {
    //true if anime quote
    // console.log(minutes+"bul");
    // {localStorage.getItem("authToken")&&await fetchUserData();}
    const minutes = todayFocusMinutes,
      epi = epiAllowed;
    if (initialQuotes) {
    } else if (Atime) {
      {
        !localStorage.getItem("authToken")
          ? setquote("Login in for Stats & Rooms") //"You've earned yourself a break! "
          : setquote("Episodes Earned: " + epi);
      }
      setheading("Break !");
    } else {
      const hours = Math.floor(minutes / 60);
      const focminutes = minutes % 60;
      {
        !localStorage.getItem("authToken")
          ? setquote("Login in for Stats & Rooms") //"Turn procastination to productivity"
          : setquote(
              "Focus Time : " + hours + " hours " + focminutes + " minutes",
            );
      }
      setheading("Focus !");
    }
  }

  const handleAnimeCompletion = async () => {
    let userEmail = localStorage.getItem("userEmail");
    let response = await fetch(
      "https://animedoro-backend.vercel.app/api/delanime",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: userEmail,
        }),
      },
    );
  };

  // const handleFocusCompletion = async () => {
  //   const oldDate = new Date();
  //   var curdate = oldDate.toDateString();
  //   let userEmail = localStorage.getItem("userEmail");
  //   let response = await fetch(
  //     "https://animedoro-backend-production.up.railway.app/api/addsession",
  //     {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         email: userEmail,
  //         minutes: timerFocusMinutes,
  //         curDate: curdate,
  //       }),
  //     }
  //   );
  // };
  const handleFocusCompletion = async (olddata) => {
    // console.log(olddata);
    const oldDate = new Date();
    var curdate = oldDate.toDateString();
    let userEmail = localStorage.getItem("userEmail");
    let mins = timerFocusMinutes;
    if (olddata) {
      // console.log("old timer", olddata);
      mins = olddata.minutes;
      curdate = olddata.curDate;
    }
    mins = Math.round(mins);
    try {
      // console.log("storing");
      let response = await fetch(
        "https://animedoro-backend.vercel.app/api/addsession",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: userEmail,
            minutes: mins,
            curDate: curdate,
          }),
        },
      );
      if (!response.ok) {
        // console.log("could not send offline");
        // Save session data locally if offline
        const offlineData = {
          type: "focus",
          userEmail: userEmail,
          minutes: mins,
          curDate: curdate,
        };
        localStorage.setItem("offlineData", JSON.stringify(offlineData));
      }
    } catch (error) {
      // Handle other errors
      // console.log("could not send offline");
      // Save session data locally if offline
      const offlineData = {
        type: "focus",
        userEmail: userEmail,
        minutes: timerFocusMinutes,
        curDate: curdate,
      };
      localStorage.setItem("offlineData", JSON.stringify(offlineData));
      console.error("Error during fetch:", error);
    }
  };

  const fetchUserData = async () => {
    // console.log("getting data");
    const oldDate = new Date();
    var curdate = oldDate.toDateString();
    let userEmail = localStorage.getItem("userEmail");
    let response = await fetch(
      "https://animedoro-backend.vercel.app/api/getstats",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: userEmail,
          curDate: curdate,
        }),
      },
    );

    const json = await response.json();
    if (response.status === 200) {
      // console.log(json.epiAllowed);
      settodayFocusMinutes(json.todayFocusMinutes);
      setepiAllowed(json.epiAllowed);
    }
  };
  // const [loading, setloading] = useState(0);
  const [quote, setquote] = useState('"Study hard, binge harder"');
  const [epiAllowed, setepiAllowed] = useState(-1);
  const [todayFocusMinutes, settodayFocusMinutes] = useState(-1);
  const [started, setstarted] = useState(false); //for buttons
  const [initialQuotes, setinitialQuotes] = useState(true);
  const [timerFocusMinutes, settimerFocusMinutes] = useState(40);
  const [timerAnimeMinutes, settimerAnimeMinutes] = useState(20);
  // const [takeStoredOnce, settakeStoredOnce] = useState(false);

  const [showToast, setshowToast] = useState(0);
  const [recoverySession, setRecoverySession] = useState(null);

  useEffect(() => {
    // Check for an interrupted focus session (device slept, tab killed, refresh)
    const rec = readActiveSession();
    if (rec) {
      // Always measure wall-clock time from when the session started,
      // regardless of manual pauses. Cap at the duration they set so
      // a short session can never award more than the timer was for.
      const elapsedMs = Date.now() - rec.startedAt;
      const recoveredMinutes = Math.min(
        Math.round(elapsedMs / 60000),
        rec.durationMinutes,
      );
      if (recoveredMinutes >= 1 && localStorage.getItem("authToken")) {
        setRecoverySession({ ...rec, minutes: recoveredMinutes });
      } else {
        clearActiveSession();
      }
    }
  }, []);

  useEffect(() => {
    // Check for pending session data on page load
    const pendingSessionData = localStorage.getItem("offlineData");
    if (pendingSessionData) {
      const parsedSessionData = JSON.parse(pendingSessionData);
      // console.log(pendingSessionData);
      if (parsedSessionData.type === "anime") {
        handleAnimeCompletion(parsedSessionData);
      } else if (parsedSessionData.type === "focus") {
        handleFocusCompletion(parsedSessionData);
      }

      // Remove pending session data from local storage
      localStorage.removeItem("offlineData");
    }
  }, []);

  useEffect(() => {
    setQuote();
    if (localStorage.getItem("FocusPeriod")) {
      settimerFocusMinutes(Number(localStorage.getItem("FocusPeriod")));
    }
    if (localStorage.getItem("AnimePeriod")) {
      settimerAnimeMinutes(Number(localStorage.getItem("AnimePeriod")));
    }

    Atime ? Animetime(-1) : Focustime(-1);
  }, [
    epiAllowed,
    todayFocusMinutes,
    Atime,
    timerAnimeMinutes,
    timerFocusMinutes,
    initialQuotes,
  ]);

  const { hours, seconds, minutes, isRunning, start, pause, resume, restart } =
    useTimer({
      expiryTimestamp,
      onExpire: async () => {
        finishaudio.play();
        clearActiveSession();
        Atime ? await Focustime(1) : await Animetime(1);
      },
      autoStart: false,
    });
  useEffect(() => {
    setTimerrunning(isRunning);
  }, [isRunning, setTimerrunning]);
  function changeTimer5(add) {
    resumeaudio.play();
    if (add) {
      if (Atime) {
        if (timerAnimeMinutes >= 60) {
          return;
        }
        settimerAnimeMinutes(timerAnimeMinutes + 5);
        localStorage.setItem("AnimePeriod", timerAnimeMinutes + 5);
      } else {
        if (timerFocusMinutes >= 180) {
          return;
        }
        settimerFocusMinutes(timerFocusMinutes + 5);
        localStorage.setItem("FocusPeriod", timerFocusMinutes + 5);
      }
    } else {
      if (Atime) {
        //change all 1 to 5
        if (timerAnimeMinutes <= 5) {
          return;
        }
        settimerAnimeMinutes(timerAnimeMinutes - 5);
        localStorage.setItem("AnimePeriod", timerAnimeMinutes - 5);
      } else {
        if (timerFocusMinutes <= 5) {
          return;
        }
        settimerFocusMinutes(timerFocusMinutes - 5); //todo change
        localStorage.setItem("FocusPeriod", timerFocusMinutes - 5);
      }
    }
    // restart(time, false);
  }

  async function Animetime(completed) {
    if (completed !== -1) {
      setinitialQuotes(false);
    }
    if (localStorage.getItem("authToken")) {
      if (completed === 1) {
        await handleFocusCompletion();
        await fetchUserData();
      }
    }
    const time = new Date();
    time.setSeconds(time.getSeconds() + 60 * timerAnimeMinutes);

    restart(time, false);
    setAtime(true);
    setstarted(false);
  }
  async function Focustime(completed) {
    if (completed !== -1) {
      setinitialQuotes(false);
    }
    if (localStorage.getItem("authToken")) {
      if (completed === 1) {
        await handleAnimeCompletion();
        await fetchUserData();
      }
    }

    const time = new Date();
    time.setSeconds(time.getSeconds() + 60 * timerFocusMinutes); //
    restart(time, false);
    setAtime(false);
    setstarted(false);
  }
  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    // console.log("updating status")
    if (user) {
      const ref = doc(db, "newusers", "allusers");
      setUserRef(ref);
      const updatestatus = async (status) => {
        if (!ref) {
          return;
        }
        await updateDoc(ref, { [user.uid]: status });
      };

      // Set the user's status to online when they log in
      let status;
      if (!isRunning) {
        status = {
          online: true,
          studying: false,
          email: user.email,
          name: user.displayName,
          img: user.photoURL,
        };
        updatestatus(status);
      } else if (!Atime && isRunning) {
        status = {
          online: true,
          studying: true,
          email: user.email,
          name: user.displayName,
          img: user.photoURL,
        };
        updatestatus(status);
      }

      // Set the user's status to offline when they close the tab or log out
      const onBeforeUnload = async (event) => {
        event.preventDefault();
        if (ref) {
          const status = {
            online: false,
            studying: false,
            email: user.email,
            name: user.displayName,
            img: user.photoURL,
          };
          await updatestatus(status);
        }
        pause();
      };
      window.addEventListener("beforeunload", onBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", onBeforeUnload);
      };
    }
  }, [isRunning]);
  useEffect(() => {
    // console.log(location.state)
    if (location.state && location.state.starttimer) {
      setautomaticTimer(location.state.starttimer);
      const newState = { ...location.state, starttimer: 0 };

      // Replace the original location state with the modified copy
      window.history.replaceState(
        { ...location },
        "",
        `${location.pathname}${location.search}`,
      );
    }
  }, [location.state]);

  const [automaticTimer, setautomaticTimer] = useState(
    location.state?.starttimer,
  );

  useEffect(() => {
    // console.log(allusers)
    if (allusers) {
      var c = 0;
      for (var i = 0; i < allusers.length; i++) {
        if (allusers[i].studying) {
          c++;
        }
      }
      setfocuspeople(c);
    }
  }, [allusers]);
  useEffect(() => {
    const button = document.getElementById("startbtn");

    if (automaticTimer) {
      setshowToast(1);
      setAtime(0);
      const checkButtonInterval = setInterval(() => {
        const button = document.getElementById("startbtn");
        if (button) {
          clearInterval(checkButtonInterval); // Stop checking for the button once it is found
          setTimeout(() => {
            // console.log("button found");
            button.click();
            // timeraudio.play();
          }, 2000);
        }
      }, 1000);
      setautomaticTimer(0);
      // setshowToast(0)
    }
  }, [automaticTimer]);

  useEffect(() => {
    if (!isRunning) {
      document.title = "Otakufy - Paused";
      return;
    }
    const curMinutes =
      hours * 60 + minutes < 10 ? "0" + minutes : hours * 60 + minutes;
    const curSeconds = seconds < 10 ? "0" + seconds : seconds;
    document.title = "⌛ " + curMinutes + " : " + curSeconds;
    return () => {};
  }, [hours, isRunning, minutes, seconds]);

  return (
    <div style={{ textAlign: "center" }}>
      <AutohideToast setShow={setshowToast} show={showToast} delay={3000} />

      {recoverySession &&
        createPortal(
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              background: "rgba(0,0,0,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                background: "#111",
                border: "1px solid #333",
                borderRadius: "12px",
                padding: "24px",
                width: "340px",
                display: "flex",
                flexDirection: "column",
                gap: "14px",
                textAlign: "left",
              }}
            >
              <strong style={{ color: "white", fontSize: "16px" }}>
                Recover your focus session?
              </strong>
              <p style={{ color: "#bbb", fontSize: "14px", margin: 0 }}>
                You started a {recoverySession.durationMinutes}-minute focus
                session at{" "}
                {new Date(recoverySession.startedAt).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
                {recoverySession.curDate !== new Date().toDateString()
                  ? ` on ${recoverySession.curDate}`
                  : ""}{" "}
                that never finished. Did you stay focused during that time?
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "flex-end",
                }}
              >
                <button
                  style={{
                    background: "none",
                    border: "1px solid #f5e8c7",
                    borderRadius: "1.2rem",
                    color: "#f5e8c7",
                    padding: "6px 18px",
                    fontSize: "14px",
                    fontWeight: 500,
                    cursor: "pointer",
                    letterSpacing: "0.01em",
                  }}
                  onClick={() => {
                    clearActiveSession();
                    setRecoverySession(null);
                  }}
                >
                  No, discard
                </button>
                <button
                  style={{
                    background: "#f5e8c7",
                    border: "1px solid #f5e8c7",
                    borderRadius: "1.2rem",
                    color: "#111",
                    padding: "6px 18px",
                    fontSize: "14px",
                    fontWeight: 500,
                    cursor: "pointer",
                    letterSpacing: "0.01em",
                  }}
                  onClick={async () => {
                    clearActiveSession();
                    const rec = recoverySession;
                    setRecoverySession(null);
                    await handleFocusCompletion({
                      minutes: rec.minutes,
                      curDate: rec.curDate,
                    });
                    await fetchUserData();
                  }}
                >
                  Yes, add {recoverySession.minutes} min
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}

      {epiAllowed === -1 && !initialQuotes ? (
        <div style={{ paddingLeft: "46%", paddingBottom: "15px" }}>
          <SpinStretch color="#F5E8C7" />
        </div>
      ) : (
        <div className={` ${onlyTimer ? "hide-toggle" : "open-toggle"}`}>
          {initialQuotes ? (
            <p className="text-center !text-base quote">
              <Typewriter
                loop
                cursor
                cursorStyle="|"
                typeSpeed={60}
                deleteSpeed={80}
                delaySpeed={1000}
                words={["Focus Hard . . .", "Binge Harder !"]}
                // onLoop={(loopCount) =>
                //   console.log(`Just completed loop ${loopCount}`)
                // }
              />
            </p>
          ) : isRunning && user ? (
            <div className="w-full flex justify-center items-center">
              <div
                onClick={() => {
                  setfocusingclick(1);
                }}
                className="tag-card  "
              >
                <div
                  className="tag-dot"
                  style={{
                    backgroundColor: Atime ? "red" : "green",
                    width: "9px",
                    height: "9px",
                    marginRight: "10px",
                  }}
                ></div>
                <p style={{ fontSize: "11px", fontWeight: "bold" }}>
                  {Atime ? "Resting" : "Focusing live"} :{" "}
                  {!Atime ? focuspeople : allusers.length - focuspeople}
                </p>
              </div>
            </div>
          ) : (
            <p
              className={`text-center !text-base quote ${
                onlyTimer ? "hide-toggle" : "open-toggle"
              }`}
              // className="text-center quote"
            >
              {" "}
              {quote}
            </p>
          )}
        </div>
      )}
      <div
        className={`flex justify-center mt-3 items-center ${onlyTimer ? "hide-toggle" : "open-toggle"}`}
      >
        <AnimatedToggle
          isRunning={isRunning}
          value={Atime ? 1 : 0}
          onChange={async (value) => {
            clearActiveSession();
            if (value === 0) {
              radioaudio.play();
              await Focustime(0);
            } else {
              radioaudio.play();
              await Animetime(0);
            }
          }}
        />
      </div>

      <div
        style={{ fontSize: "100px" }}
        className={`clock-font ${onlyTimer ? "enlarged mt-1" : ""}`}
        onChange={async () => {
          await Animetime(0);
        }}
      >
        {" "}
        {!started && (
          <span className={`${onlyTimer ? "hide-toggle" : "open-toggle"}`}>
            <button
              onClick={() => {
                changeTimer5(false);
              }}
              // className="btn btn-outline-secondary btn-timer m-3"
              className={`btn btn-outline-secondary btn-timer m-3 ${
                onlyTimer ? "hide-toggle" : "open-toggle"
              }`}
              style={{
                padding: "3px",
                paddingLeft: "6px",
                paddingRight: "6px",
              }}
            >
              -
            </button>
          </span>
        )}
        {/* timer display */}
        <span>
          {hours * 60 + minutes < 10 ? "0" + minutes : hours * 60 + minutes}
        </span>
        :<span>{seconds < 10 ? "0" + seconds : seconds}</span>
        {!started && (
          <span>
            <button
              onClick={() => {
                changeTimer5(true);
              }}
              // className=""
              className={`btn btn-outline-secondary btn-timer m-3 ${
                onlyTimer ? "hide-toggle" : "open-toggle"
              }`}
              style={{
                padding: "3px",
                paddingLeft: "6px",
                paddingRight: "6px",
              }}
            >
              +
            </button>
          </span>
        )}
      </div>

      <div
        className={`my-3 !text-base quote ${onlyTimer ? "hide-toggle" : "open-toggle"}`}
        //  className="quote"
      >
        {isRunning ? "Running" : "Paused"}
      </div>
      <TimerPiP
        pipOpen={pipOpen}
        onPipClose={onPipClose}
        minutesText={
          hours * 60 + minutes < 10 ? "0" + minutes : hours * 60 + minutes
        }
        secondsText={seconds < 10 ? "0" + seconds : seconds}
        isRunning={isRunning}
        started={started}
        Atime={Atime}
        onPause={() => {
          pauseaudio.play();
          pause();
        }}
        onResume={() => {
          resumeaudio.play();
          resume();
        }}
      />
      {!started && (
        <div
          // style={{}}
          className={`mt-3 ${onlyTimer ? "hide-toggle" : "open-toggle"}`}
          // style={{ marginLeft: "-10px" }}
        >
          <button
            id="startbtn"
            onClick={async () => {
              Atime ? await Animetime(0) : await Focustime(0);
              timeraudio.play();
              setstarted(true);
              start();
              if (!Atime) saveActiveSession(timerFocusMinutes);
            }}
            className="btn btn-outline-secondary btn-timer d-inline-block font-mod rounded-full px-3 "
          >
            {/* todo:start */}
            Start
          </button>
          {/* <div className="d-inline-block ml-2 settingsbutton"
        onClick={()=>{setwallpaperclick(1)}}>
        <SettingsOutlinedIcon fontSize="small"/>
        </div> */}
          {/* <div className="d-inline-block ml-2 settingsbutton"
        onClick={()=>{setbreathevisible(prev=>!prev)}}>
        <AirOutlinedIcon fontSize="small"/>
        </div> */}
        </div>
      )}
      {started && isRunning && (
        <button
          // style={{display:!onlyTimer?"":"none"}}
          className={`btn btn-outline-secondary btn-timer font-mod rounded-full px-3 ${
            onlyTimer ? "hide-toggle" : "open-toggle"
          }`}
          // className="btn btn-outline-secondary btn-timer"
          onClick={() => {
            pauseaudio.play();
            pause();
          }}
        >
          Pause
        </button>
      )}
      {started && !isRunning && (
        <button
          // style={{display:!onlyTimer?"":"none"}}
          className={`btn btn-outline-secondary btn-timer font-mod rounded-full px-3 ${
            onlyTimer ? "hide-toggle" : "open-toggle"
          }`}
          disabled={minutes === 0 && seconds === 0}
          // className="btn btn-outline-secondary btn-timer"
          onClick={() => {
            resumeaudio.play();
            resume();
          }}
        >
          {minutes === 0 && seconds === 0 ? (
            <span
              className="spinner-border spinner-border-sm "
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            <>Resume</>
          )}
        </button>
      )}
      {Atime && <NetButton onlyTimer={onlyTimer} />}

      {/* Spotifyyyyyyyyyy */}

      {!Atime && <Music onlyTimer={onlyTimer} />}

      {timerMaximized &&
        createPortal(
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              background: "rgb(11, 9, 9)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "clamp(10px, 2.5vh, 28px)",
            }}
          >
            {/* ── Minimize ── */}
            <button
              onClick={onMaximizeClose}
              title="Minimize (Esc)"
              style={{
                position: "absolute",
                top: "22px",
                right: "28px",
                background: "transparent",
                border: "1px solid #f5e8c744",
                color: "#f5e8c799",
                borderRadius: "9999px",
                padding: "8px 20px",
                fontSize: "clamp(11px, 1.2vw, 14px)",
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: "bold",
                letterSpacing: "0.05em",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.99988 8H3.19988C4.88004 8 5.72011 8 6.36185 7.67302C6.92634 7.3854 7.38528 6.92646 7.6729 6.36197C7.99988 5.72024 7.99988 4.88016 7.99988 3.2V3M2.99988 16H3.19988C4.88004 16 5.72011 16 6.36185 16.327C6.92634 16.6146 7.38528 17.0735 7.6729 17.638C7.99988 18.2798 7.99988 19.1198 7.99988 20.8V21M15.9999 3V3.2C15.9999 4.88016 15.9999 5.72024 16.3269 6.36197C16.6145 6.92646 17.0734 7.3854 17.6379 7.67302C18.2796 8 19.1197 8 20.7999 8H20.9999M15.9999 21V20.8C15.9999 19.1198 15.9999 18.2798 16.3269 17.638C16.6145 17.0735 17.0734 16.6146 17.6379 16.327C18.2796 16 19.1197 16 20.7999 16H20.9999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Minimize
            </button>

            {/* ── Mode label ── */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px", opacity: 0.75 }}>
              <div style={{
                width: "clamp(9px, 1vw, 14px)",
                height: "clamp(9px, 1vw, 14px)",
                borderRadius: "50%",
                backgroundColor: Atime ? "red" : "green",
                flexShrink: 0,
              }} />
              <span style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "clamp(0.75rem, 1.4vw, 1.4rem)",
                fontWeight: "bold",
                letterSpacing: "3px",
                textTransform: "uppercase",
                color: "#f5e8c7d1",
              }}>
                {Atime ? "Break" : "Focus"}
              </span>
            </div>

            {/* ── Toggle — hidden while running ── */}
            {!isRunning && (
              <AnimatedToggle
                isRunning={isRunning}
                value={Atime ? 1 : 0}
                onChange={async (value) => {
                  clearActiveSession();
                  if (value === 0) { radioaudio.play(); await Focustime(0); }
                  else { radioaudio.play(); await Animetime(0); }
                }}
              />
            )}

            {/* ── Big clock — click to pause / resume once started ── */}
            <div
              onClick={() => {
                if (!started) return;
                if (isRunning) { pauseaudio.play(); pause(); }
                else if (minutes !== 0 || seconds !== 0) { resumeaudio.play(); resume(); }
              }}
              style={{
                fontFamily: "'Righteous', cursive",
                fontSize: "clamp(6rem, 24vw, 26rem)",
                color: "#f5e8c7d1",
                lineHeight: 1,
                cursor: started ? "pointer" : "default",
                userSelect: "none",
              }}
            >
              {hours * 60 + minutes < 10 ? "0" + minutes : hours * 60 + minutes}
              :{seconds < 10 ? "0" + seconds : seconds}
            </div>

            {/* ── Tap hint when running ── */}
            {started && (
              <div style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "clamp(0.65rem, 1.1vw, 1rem)",
                color: "#f5e8c744",
                letterSpacing: "2px",
                textTransform: "uppercase",
              }}>
                {minutes === 0 && seconds === 0
                  ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                  : (isRunning ? "tap to pause" : "tap to resume")
                }
              </div>
            )}

            {/* ── Pre-start controls: +/− and Start ── */}
            {!started && (
              <div style={{ display: "flex", alignItems: "center", gap: "clamp(12px, 2vw, 28px)", marginTop: "8px" }}>
                <button
                  onClick={() => changeTimer5(false)}
                  className="btn btn-outline-secondary btn-timer font-mod"
                  style={{ fontSize: "clamp(1rem, 2vw, 1.6rem)", padding: "4px 16px", borderRadius: "9999px" }}
                >
                  −
                </button>
                <button
                  onClick={async () => {
                    Atime ? await Animetime(0) : await Focustime(0);
                    timeraudio.play();
                    setstarted(true);
                    start();
                    if (!Atime) saveActiveSession(timerFocusMinutes);
                  }}
                  className="btn btn-outline-secondary btn-timer font-mod rounded-full"
                  style={{ fontSize: "clamp(0.9rem, 1.6vw, 1.4rem)", padding: "8px 32px", borderRadius: "9999px" }}
                >
                  Start
                </button>
                <button
                  onClick={() => changeTimer5(true)}
                  className="btn btn-outline-secondary btn-timer font-mod"
                  style={{ fontSize: "clamp(1rem, 2vw, 1.6rem)", padding: "4px 16px", borderRadius: "9999px" }}
                >
                  +
                </button>
              </div>
            )}
          </div>,
          document.body
        )}
    </div>
  );
}
// const MemoizedTimer = React.memo(Timer);

// export default MemoizedTimer;

export default Timer;
